/**
 * 班课api
 * 班课相关界面api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The AccountSummaryVo model module.
   * @module clazz_course/model/AccountSummaryVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>AccountSummaryVo</code>.
   * @alias module:clazz_course/model/AccountSummaryVo
   * @class
   */
  var exports = function() {
    var _this = this;






  };

  /**
   * Constructs a <code>AccountSummaryVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:clazz_course/model/AccountSummaryVo} obj Optional instance to populate.
   * @return {module:clazz_course/model/AccountSummaryVo} The populated <code>AccountSummaryVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'avatarUrl')) {
        obj['avatarUrl'] = ApiClient.convertToType(data['avatarUrl'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'idNumber')) {
        obj['idNumber'] = ApiClient.convertToType(data['idNumber'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'phoneNum')) {
        obj['phoneNum'] = ApiClient.convertToType(data['phoneNum'], 'String');
      }
    }
    return obj;
  }

  /**
   * accountId
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 姓名
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * 头像
   * @member {String} avatarUrl
   */
  exports.prototype['avatarUrl'] = undefined;
  /**
   * 身份证号
   * @member {String} idNumber
   */
  exports.prototype['idNumber'] = undefined;
  /**
   * 手机号
   * @member {String} phoneNum
   */
  exports.prototype['phoneNum'] = undefined;



  export default exports;
;


